import {Component, Input, OnInit} from '@angular/core';
import {CashbackService} from '../../../../core/service/cashback.service';
import {ShopSummary} from '../../../../core/models/shopSummary';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-cashback-shop-list',
  templateUrl: './cashback-shop-list.component.html',
  styleUrls: ['./cashback-shop-list.component.scss'],
  providers: [TranslatePipe]
})
export class CashbackShopListComponent implements OnInit {

  public shops: Array<ShopSummary> = [];
  public shopsCategory: any[] = [];
  public filteredCollection: Array<ShopSummary> = [];
  public searchText = '';
  public subdomain: string;
  public appliedFilters: any = {};
  public unconfirmedFilters: any = {};
  public filtersOutdated = false;
  private initialFiltersFromUrl = false;

  constructor(private cashbackService: CashbackService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslatePipe,
    private toastrService: ToastrService) {
    this.subdomain = this.activeRoute.snapshot.params['subdomain'];
    this.initialFiltersFromUrl = !!this.activeRoute.snapshot.queryParams['categories'];
  }

  ngOnInit(): void {
    this.cashbackService.getSummaryForShops()
      .subscribe({
        next: value => {
          this.shops = value.filter(s => s.couponCount > 0 || s.hasCashback);
        this.shopsCategory = this.getUniqueCategories(this.shops);
          this.filteredCollection = this.shops;
        },
        error: err => {
          this.shops = [];
          this.toastrService.error(
            this.translate.transform('CASHBACK.LIST_PAGE.LOAD_FAILED'),
            this.translate.transform('ERROR'),
            { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
          );
          this.router.navigate([`${this.subdomain}/home`]);
        }
      });
  }

  navigateToDetails(id: string) {
    this.router.navigate([`/${this.subdomain}/deals/${id}`]);
  }

  public changeFilters(filters: any): void {
    this.unconfirmedFilters = { ...this.unconfirmedFilters, ...filters };
    this.filtersOutdated = true;
    if (this.initialFiltersFromUrl) {
      this.initialFiltersFromUrl = false;
      this.applyFilters();
    }
  }

  public applyFilters(): void {
    if (!this.filtersOutdated) {
      return;
    }
    this.appliedFilters = { ...this.unconfirmedFilters };
    this.filtersOutdated = false;
    this.filterAndSearch();
  }

  private filterAndSearch(): void {
    let collection = [...this.shops];
  
    if (this.appliedFilters?.categories?.length > 0) {
      collection = collection.filter(shop => this.appliedFilters.categories.includes(shop.category));
    }
  
    this.filteredCollection = collection;
  }

  public resetAllFilters(): void {
    this.appliedFilters = {};
    this.unconfirmedFilters = {};
    this.filtersOutdated = false;
    this.filteredCollection = [...this.shops];
  }

  public getUniqueCategories(shops: ShopSummary[]): string[] {
    const categories: string[] = shops
      .map(shop => shop.category)
      .filter(category => typeof category === 'string' && category.trim() !== '');
    return Array.from(new Set(categories)).sort((a, b) => a.localeCompare(b));
  }
}
